
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import MobileBottomNav from '../../components/feature/MobileBottomNav';



export default function Wallet() {
  const [activeMethod, setActiveMethod] = useState(null);
  const [amount, setAmount] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [copiedField, setCopiedField] = useState(null);

  const quickAmounts = [1000, 2000, 5000, 10000, 20000, 50000];

  const bankDetails = {
    bankName: 'Wema Bank',
    accountNumber: '7825463901',
    accountName: 'VTU App - John Doe',
  };

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 2000);
  };

  const handleCardPayment = () => {
    if (!amount) return;
    
    setIsProcessing(true);
    setTimeout(() => {
      setIsProcessing(false);
      setShowSuccess(true);
    }, 2000);
  };

  const handleConfirmBankTransfer = () => {
    if (!amount) return;
    
    setIsProcessing(true);
    setTimeout(() => {
      setIsProcessing(false);
      setShowSuccess(true);
    }, 1500);
  };

  const resetForm = () => {
    setShowSuccess(false);
    setAmount('');
    setActiveMethod(null);
  };

  if (showSuccess) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-navy-50 via-white to-cyan-50">
        <Navbar />
        <main className="max-w-lg mx-auto px-4 py-8 pb-24 md:pb-8">
          <div className="bg-white rounded-xl p-8 shadow-sm text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-check-line text-4xl text-green-600"></i>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              {activeMethod === 'bank' ? 'Transfer Initiated!' : 'Payment Successful!'}
            </h2>
            <p className="text-gray-600 mb-2">
              {activeMethod === 'bank' 
                ? 'Your wallet will be credited once we confirm your transfer.'
                : `₦${Number(amount).toLocaleString()} has been added to your wallet.`
              }
            </p>
            {activeMethod === 'bank' && (
              <p className="text-sm text-gray-500 mb-6">
                This usually takes 1-5 minutes. You'll receive a notification once credited.
              </p>
            )}
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <div className="flex justify-between text-sm mb-2">
                <span className="text-gray-600">Amount</span>
                <span className="font-semibold text-gray-900">₦{Number(amount).toLocaleString()}</span>
              </div>
              <div className="flex justify-between text-sm mb-2">
                <span className="text-gray-600">Method</span>
                <span className="font-semibold text-gray-900 capitalize">{activeMethod === 'bank' ? 'Bank Transfer' : 'Card Payment'}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Reference</span>
                <span className="font-semibold text-gray-900">VTU{Date.now().toString().slice(-8)}</span>
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={resetForm}
                className="flex-1 py-3 border border-navy-600 text-navy-600 rounded-lg font-semibold hover:bg-navy-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Fund Again
              </button>
              <a
                href="/"
                className="flex-1 py-3 bg-navy-600 text-white rounded-lg font-semibold hover:bg-navy-700 transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                Go to Dashboard
              </a>
            </div>
          </div>
        </main>
        <MobileBottomNav />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-50 via-white to-cyan-50">
      <Navbar />
      
      <main className="max-w-2xl mx-auto px-4 py-4 md:py-8 pb-24 md:pb-8">
        {/* Header */}
        <div className="mb-6">
          <a href="/" className="inline-flex items-center text-navy-600 hover:text-navy-700 mb-4 cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Dashboard
          </a>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1">Fund Wallet</h1>
          <p className="text-sm md:text-base text-gray-600">Add money to your VTU wallet</p>
        </div>

        {/* Amount Input */}
        <div className="bg-white rounded-xl p-4 md:p-6 shadow-sm mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Enter Amount</label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 font-semibold">₦</span>
            <input
              type="text"
              value={amount}
              onChange={(e) => setAmount(e.target.value.replace(/[^0-9]/g, ''))}
              placeholder="0.00"
              className="w-full pl-10 pr-4 py-3 md:py-4 text-xl md:text-2xl font-bold border border-gray-300 rounded-lg focus:ring-2 focus:ring-navy-500 focus:border-navy-500 outline-none"
            />
          </div>
          
          {/* Quick Amount Buttons */}
          <div className="grid grid-cols-3 gap-2 mt-4">
            {quickAmounts.map((quickAmount) => (
              <button
                key={quickAmount}
                onClick={() => setAmount(quickAmount.toString())}
                className={`py-2 px-3 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  amount === quickAmount.toString()
                    ? 'bg-navy-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                ₦{quickAmount.toLocaleString()}
              </button>
            ))}
          </div>
        </div>

        {/* Payment Method Selection */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-4">
          <div className="p-4 md:p-6">
            <h3 className="font-semibold text-gray-900 mb-4">Select Payment Method</h3>
            
            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={() => setActiveMethod('card')}
                className={`p-4 md:p-6 rounded-xl border-2 transition-all cursor-pointer ${
                  activeMethod === 'card'
                    ? 'border-navy-600 bg-navy-50'
                    : 'border-gray-200 hover:border-navy-300 hover:bg-gray-50'
                }`}
              >
                <div className="w-12 h-12 bg-navy-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-bank-card-line text-2xl text-navy-600"></i>
                </div>
                <p className="font-semibold text-gray-900 text-sm md:text-base">Card</p>
                <p className="text-xs text-gray-500 mt-1">Debit/Credit Card</p>
              </button>

              <button
                onClick={() => setActiveMethod('bank')}
                className={`p-4 md:p-6 rounded-xl border-2 transition-all cursor-pointer ${
                  activeMethod === 'bank'
                    ? 'border-navy-600 bg-navy-50'
                    : 'border-gray-200 hover:border-navy-300 hover:bg-gray-50'
                }`}
              >
                <div className="w-12 h-12 bg-navy-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-bank-line text-2xl text-navy-600"></i>
                </div>
                <p className="font-semibold text-gray-900 text-sm md:text-base">Bank Transfer</p>
                <p className="text-xs text-gray-500 mt-1">Direct Transfer</p>
              </button>
            </div>
          </div>
        </div>

        {/* Card Payment Section */}
        {activeMethod === 'card' && (
          <div className="bg-white rounded-xl p-4 md:p-6 shadow-sm mb-4">
            <div className="text-center py-4">
              <div className="w-16 h-16 bg-navy-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-bank-card-line text-3xl text-navy-600"></i>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Pay with Card</h3>
              <p className="text-sm text-gray-600 mb-4">
                You'll be redirected to a secure payment page to complete your transaction.
              </p>
              <div className="flex items-center justify-center gap-2 mb-6">
                <i className="ri-shield-check-line text-green-600"></i>
                <span className="text-xs text-gray-600">Secured with 256-bit SSL encryption</span>
              </div>
            </div>

            <button
              onClick={handleCardPayment}
              disabled={!amount || Number(amount) < 100 || isProcessing}
              className="w-full py-3 md:py-4 bg-navy-600 text-white rounded-lg font-semibold hover:bg-navy-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
            >
              {isProcessing ? (
                <span className="flex items-center justify-center">
                  <i className="ri-loader-4-line animate-spin mr-2"></i>
                  Processing...
                </span>
              ) : (
                `Pay ₦${amount ? Number(amount).toLocaleString() : '0'}`
              )}
            </button>
          </div>
        )}

        {/* Bank Transfer Section */}
        {activeMethod === 'bank' && (
          <div className="bg-white rounded-xl p-4 md:p-6 shadow-sm mb-4">
            <div className="bg-gradient-to-br from-navy-50 to-cyan-50 rounded-lg p-4 md:p-6 mb-4">
              <p className="text-sm text-gray-600 mb-4">
                Transfer to the account below. Your wallet will be credited automatically.
              </p>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="text-xs text-gray-500">Bank Name</p>
                    <p className="font-semibold text-gray-900">{bankDetails.bankName}</p>
                  </div>
                  <button
                    onClick={() => copyToClipboard(bankDetails.bankName, 'bank')}
                    className="p-2 text-navy-600 hover:bg-navy-100 rounded-lg transition-colors cursor-pointer"
                  >
                    <i className={`${copiedField === 'bank' ? 'ri-check-line' : 'ri-file-copy-line'}`}></i>
                  </button>
                </div>
                
                <div className="flex justify-between items-center">
                  <div>
                    <p className="text-xs text-gray-500">Account Number</p>
                    <p className="font-semibold text-gray-900 text-lg">{bankDetails.accountNumber}</p>
                  </div>
                  <button
                    onClick={() => copyToClipboard(bankDetails.accountNumber, 'account')}
                    className="p-2 text-navy-600 hover:bg-navy-100 rounded-lg transition-colors cursor-pointer"
                  >
                    <i className={`${copiedField === 'account' ? 'ri-check-line' : 'ri-file-copy-line'}`}></i>
                  </button>
                </div>
                
                <div className="flex justify-between items-center">
                  <div>
                    <p className="text-xs text-gray-500">Account Name</p>
                    <p className="font-semibold text-gray-900">{bankDetails.accountName}</p>
                  </div>
                  <button
                    onClick={() => copyToClipboard(bankDetails.accountName, 'name')}
                    className="p-2 text-navy-600 hover:bg-navy-100 rounded-lg transition-colors cursor-pointer"
                  >
                    <i className={`${copiedField === 'name' ? 'ri-check-line' : 'ri-file-copy-line'}`}></i>
                  </button>
                </div>
              </div>
            </div>

            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4">
              <div className="flex items-start gap-2">
                <i className="ri-information-line text-amber-600 mt-0.5"></i>
                <div className="text-sm text-amber-800">
                  <p className="font-medium mb-1">Important</p>
                  <ul className="list-disc list-inside space-y-1 text-xs">
                    <li>Transfer only the exact amount entered above</li>
                    <li>Wallet is credited within 1-5 minutes</li>
                    <li>Minimum funding amount is ₦100</li>
                  </ul>
                </div>
              </div>
            </div>

            <button
              onClick={handleConfirmBankTransfer}
              disabled={!amount || Number(amount) < 100 || isProcessing}
              className="w-full py-3 md:py-4 bg-navy-600 text-white rounded-lg font-semibold hover:bg-navy-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
            >
              {isProcessing ? (
                <span className="flex items-center justify-center">
                  <i className="ri-loader-4-line animate-spin mr-2"></i>
                  Processing...
                </span>
              ) : (
                "I've Made the Transfer"
              )}
            </button>
          </div>
        )}

        {/* Recent Funding History */}
        <div className="bg-white rounded-xl p-4 md:p-6 shadow-sm">
          <h3 className="font-semibold text-gray-900 mb-4">Recent Funding</h3>
          <div className="space-y-3">
            {[
              { amount: 10000, method: 'Bank Transfer', date: 'Today, 2:30 PM', status: 'success' },
              { amount: 5000, method: 'Card Payment', date: 'Yesterday, 10:15 AM', status: 'success' },
              { amount: 20000, method: 'Bank Transfer', date: 'Dec 15, 4:45 PM', status: 'success' },
            ].map((item, index) => (
              <div key={index} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <i className="ri-add-line text-green-600"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900 text-sm">₦{item.amount.toLocaleString()}</p>
                    <p className="text-xs text-gray-500">{item.method}</p>
                  </div>
                </div>
                <div className="text-right">
                  <span className="text-xs text-green-600 font-medium">Successful</span>
                  <p className="text-xs text-gray-500">{item.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <MobileBottomNav />
    </div>
  );
}
